// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-permission-containers {
  overflow: hidden;
}
.role-permission-containers .role-permission-main {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.role-permission-containers .role-permission {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 90vh;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.role-permission-containers .role-permission::-webkit-scrollbar {
  display: none;
}
.role-permission-containers .header-navigation {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
  width: 99.5%;
}
.role-permission-containers .roles-permission-text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.role-permission-containers .roles-users-section {
  width: 98%;
  margin: auto;
}
.role-permission-containers .page-navigation-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 16px;
  border-bottom: 1px solid #C1C6C0;
  width: 98%;
}
.role-permission-containers .navigation-button-flex {
  display: flex;
  gap: 10px;
}
.role-permission-containers .action-button {
  margin-top: 1px;
}
.role-permission-containers .action-button button {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  font-weight: 700;
  font-size: 16px;
  color: #ebe9e9 !important;
  width: 100% !important;
  border: none;
  word-wrap: none;
  white-space: nowrap;
}
.role-permission-containers .page-navigation-buttons button {
  padding: 10px 20px;
  background-color: #E5F0FF;
  color: #333;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: auto;
  font-weight: 600;
}
.role-permission-containers .page-navigation-buttons button.active {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  color: white;
  border: 1px solid #0C3688;
}

@media screen and (max-width: 786px) {
  .role-permission-containers .role-permission-main {
    flex-direction: column;
  }
  .role-permission-containers .role-permission-main .role-permission {
    width: 100%;
  }
  .role-permission-containers .role-permission-main .page-navigation-buttons {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .role-permission-containers .role-permission-main .navigation-button-flex {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 480px) {
  .navigation-button-flex {
    flex-direction: column;
    width: 100%;
  }
  .page-navigation-buttons button {
    width: 100% !important;
  }
  .action-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/RolesAndUsers/RolesAndUser.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAEI;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,wBAAA;AAAR;AAGI;EACI,aAAA;AADR;AAII;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAFR;AAKI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAHR;AAMI;EACI,UAAA;EACA,YAAA;AAJR;AAOI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,UAAA;AALR;AAQI;EACI,aAAA;EACA,SAAA;AANR;AASI;EACI,eAAA;AAPR;AAUI;EACI,mEAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AARR;AAWI;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,iCAAA;EACA,WAAA;EACA,gBAAA;AATR;AAYI;EACI,mEAAA;EACA,YAAA;EACA,yBAAA;AAVR;;AAeA;EACI;IACI,sBAAA;EAZN;EAcO;IACG,WAAA;EAZV;EAeO;IACG,sBAAA;IACA,uBAAA;IACA,SAAA;EAbV;EAgBO;IACG,eAAA;EAdV;AACF;AAoBA;EACI;IACI,sBAAA;IACA,WAAA;EAlBN;EAqBG;IACG,sBAAA;EAnBN;EAsBG;IACG,WAAA;EApBN;AACF","sourcesContent":[".role-permission-containers {\n    overflow: hidden;\n\n    .role-permission-main {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .role-permission {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 90vh;\n        scrollbar-width: none;\n        -ms-overflow-style: none;\n    }\n\n    .role-permission::-webkit-scrollbar {\n        display: none;\n    }\n\n    .header-navigation {\n        background: #c0c8da;\n        height: 2.4rem;\n        border: 1px solid #c0c8da;\n        width: 99.5%;\n    }\n\n    .roles-permission-text {\n        font-family: \"Nunito\";\n        font-size: 12px;\n        font-weight: 500;\n        color: #2D2D2D;\n        padding: 0.5rem;\n    }\n\n    .roles-users-section{\n        width: 98%;\n        margin: auto;\n    }\n\n    .page-navigation-buttons {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 30px;\n        margin-top: 16px;\n        border-bottom: 1px solid #C1C6C0;\n        width: 98%;\n    }\n\n    .navigation-button-flex{\n        display: flex;\n        gap: 10px;\n    }\n\n    .action-button{\n        margin-top: 1px;\n    }\n\n    .action-button button{\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        font-weight: 700;\n        font-size: 16px;\n        color: #ebe9e9 !important;\n        width: 100% !important;\n        border: none;\n        word-wrap: none;\n        white-space: nowrap;\n    }\n    \n    .page-navigation-buttons button {\n        padding: 10px 20px;\n        background-color: #E5F0FF;\n        color: #333;\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n        width: auto;\n        font-weight: 600;\n    }\n    \n    .page-navigation-buttons button.active {\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        color: white;\n        border: 1px solid #0C3688;\n    }\n    \n}\n\n@media screen and (max-width: 786px) {\n    .role-permission-containers .role-permission-main{\n        flex-direction: column;\n\n         .role-permission{\n            width: 100%;\n         }\n\n         .page-navigation-buttons {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 20px;\n         }\n\n         .navigation-button-flex {\n            flex-wrap: wrap;\n         }\n    }\n\n    \n}\n\n@media screen and (max-width: 480px) {\n    .navigation-button-flex {\n        flex-direction: column;\n        width: 100%;\n     }\n\n     .page-navigation-buttons button{\n        width: 100% !important;\n     }\n\n     .action-button{\n        width: 100%;\n     }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
